import { render, staticRenderFns } from "./PreviewPdf.vue?vue&type=template&id=2a035ce6&scoped=true"
import script from "./PreviewPdf.vue?vue&type=script&lang=js"
export * from "./PreviewPdf.vue?vue&type=script&lang=js"
import style0 from "./PreviewPdf.vue?vue&type=style&index=0&id=2a035ce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a035ce6",
  null
  
)

export default component.exports